/**
 * AR9b: user-supplied LLM API key, persisted in browser localStorage. When set,
 * it's attached as the `X-LLM-API-Key` header (see services/chatapi.js) and the
 * backend uses it to override the server-configured key for that request.
 */
const STORAGE_KEY = 'llm_api_key';

export function getLlmApiKey() {
  try {
    return (typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY)) || '';
  } catch {
    return '';
  }
}

export function setLlmApiKey(key) {
  try {
    if (key) window.localStorage.setItem(STORAGE_KEY, key);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* localStorage unavailable */ }
}

export function clearLlmApiKey() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* localStorage unavailable */ }
}
